import DOMPurify from "dompurify";

import { signatureToEmailHtml } from "@lytra/frontend-common/lib/markdown";
import { useFeature, useProfile } from "@/providers/ProfileProvider";

/**
 * The signature lytra puts under a mail it sends itself (a direct reply, a share by
 * mail): with feature.user-signature on, the user's stored HTML variant, else the
 * plain-text one rendered as HTML. Null when the flag is off or the user has no
 * signature; then the mail carries none. Sanitized: it is rendered in the page and goes
 * out in the mail.
 */
export function useSendSignatureHtml(): string | null {
  const { user } = useProfile();
  const enabled = useFeature("user-signature");
  if (!enabled) return null;
  const html = user ? signatureToEmailHtml(user) : null;
  return html
    ? DOMPurify.sanitize(html, { USE_PROFILES: { html: true } })
    : null;
}
